import React from 'react';
import PropTypes from 'prop-types';

const VERTICAL = 'vertial';
const HORIZONTAL = 'horizontal';

const hoScrollBarWidth = 0.6;
const veScrollBarWidth = 0.4;

const styles = {
    main: {
        overflow: 'hidden',
        position: 'relative',
        boxSizing: 'border-box'
    },
    container: {
        // position: 'absolute',
        top: '0',
        left: '0',
        overflow: 'scroll',

        position: 'relative',
        boxSizing: 'border-box'
    },
    track: {
        vertical: {
            position: 'absolute',
            top: '0',
            right: '0',
            width: `${veScrollBarWidth}rem`,
            transition: 'opacity 0.3s',
            // backgroundColor: '#000000',
            zIndex: "10",
            //borderLeft: '0.0635rem solid #E8E8E8',
        },
        // verticalCustomize: {

        // },
        horizontal: {
            position: 'absolute',
            left: '0',
            bottom: '0',
            height: `${hoScrollBarWidth}rem`,
            transition: 'opacity 0.3s',
            // backgroundColor: '#ffffff',
            zIndex: "10",
            //borderTop: '0.06375rem solid #E8E8E8',
        },
        // horizontalCustomize: {

        // }
    },
    handler: {
        vertical: {
            position: 'absolute',
            width: '100%',
            backgroundColor: '#cccccc',
            borderRadius: '0.25rem',
            transition: 'opacity 0.3s',
            cursor: "pointer",
        },
        // verticalCustomize: {

        // },
        horizontal: {
            position: 'absolute',
            height: '100%',
            backgroundColor: '#cccccc',
            borderRadius: '0.25rem',
            transition: 'opacity 0.3s',
            cursor: "pointer",
        },
        // horizontalCustomize: {

        // }
    },
    square: {
        position: 'absolute',
        width: '0.6rem',
        height: '0.6rem',
        right: 0,
        bottom: 0,
        backgroundColor: 'white'
    }
};

export default class ScrollBox extends React.PureComponent {
    static displayName = 'FreeScrollbar';

    static propTypes = {
        className: PropTypes.string,
        style: PropTypes.object,
        fixed: PropTypes.bool,
        autohide: PropTypes.bool,
        timeout: PropTypes.number,
        tracksize: PropTypes.string,
        start: PropTypes.string,
        scrollWrapColor: PropTypes.string,
        // browserOffset: PropTypes.string,
        onScrollbarScroll: PropTypes.func,
        onScrollbarScrollTimeout: PropTypes.number
    };

    static defaultProps = {
        className: '',
        style: {
            // width: '100%',
            // height: '100%'
        },
        scrollWrapColor: "#ffffff",
        fixed: true,
        autohide: false,
        timeout: 2000,
        tracksize: '0.6rem',
        start: 'top left',
        // browserOffset: '1.2625rem',// '1.0625rem'
        onScrollbarScroll: null,
        onScrollbarScrollTimeout: 100
    };

    el = null;
    // offsetHeight = 0;
    // offsetWidth = 0;
    lastScrollHeight = 0;
    lastScrollWidth = 0;
    activeHandler = null;
    lastMousePos = null;
    lastContainerScrollTop = 0;
    lastContainerScrollLeft = 0;
    handlerHider = null;

    /** All prop funcs should be built to this funcs to run */
    /** @function {Function} - prop func */
    scrollbarScrollThrottle = null;

    constructor(props) {
        super(props);

        this.state = {
            showVeriticalTrack: false,
            showHorizontalTrack: false,
            noselect: false,
            handlerPos: {
                top: 0,
                left: 0
            },
            hideHandler: props.autohide,
            browserOffset: 1.0625
        };

        // build prop funcs
        this.scrollbarScrollThrottle = props.onScrollbarScrollTimeout > 0 ? this.throttle(props.onScrollbarScroll, props.onScrollbarScrollTimeout) : props.onScrollbarScroll;
    }


    handleReadyStateChange = () => {
        if (document.readyState === 'complete') {
            this.prepareScrollbar();
        }
    };

    prepareScrollbar = () => {
        // this.collectInfo();
        this.updateTrackVisibilities();
        this.handlerContainerScroll();
        if (this.props.start.includes('bottom')) {
            this.el.scrollTop = this.el.scrollHeight;
        }
        if (this.props.start.includes('right')) {
            this.el.scrollLeft = this.el.scrollWidth;
        }
    };

    // collectInfo = () => {
    //     this.offsetWidth = this.el.offsetWidth;
    //     this.offsetHeight = this.el.offsetHeight;
    // }

    updateTrackVisibilities = () => {
        let {el} = this;
        let {scrollHeight, scrollWidth} = el;

        if (scrollHeight === this.lastScrollHeight && scrollWidth === this.lastScrollWidth) return;
        this.setState({
            showVeriticalTrack: scrollHeight > this.el.offsetHeight,
            showHorizontalTrack: scrollWidth > this.el.offsetWidth
        });
        this.lastScrollWidth = scrollWidth;
        this.lastScrollHeight = scrollHeight;
    };

    runFunc = (funcName, ...args) => {
        if (this[funcName]) {
            this[funcName](args);
        }
    };

    throttle = (func, timeout) => {
        if (!func) return null;

        let canRun = true;

        return function (...args) {

            if (canRun) {
                canRun = false;
                func(...args);

                setTimeout(() => {
                    canRun = true;
                }, timeout);
            }
        };
    };

    handlerContainerScroll = e => {
        if (this.props.autohide) {
            clearTimeout(this.handlerHider);
            this.setState({hideHandler: false});
            this.handlerHider = setTimeout(() => {
                this.setState({hideHandler: true});
            }, this.props.timeout);
        }

        var el = this.el;
        var top = el.scrollTop / (el.scrollHeight - el.offsetHeight) * (1 - el.offsetHeight / this.lastScrollHeight) * 100;
        var bottom = (1 - (el.scrollTop + el.offsetHeight) / (el.scrollHeight - el.offsetHeight) * (1 - el.offsetHeight / this.lastScrollHeight)) * 100;
        if (bottom < 0) bottom = 0;
        var left = el.scrollLeft / (el.scrollWidth - el.offsetWidth) * (1 - el.offsetWidth / this.lastScrollWidth) * 100;
        var right = (1 - (el.scrollLeft + el.offsetWidth) / (el.scrollWidth - el.offsetWidth) * (1 - el.offsetWidth / this.lastScrollWidth)) * 100;
        if (right < 0) right = 0;
        var requestFlag = this.props.requestFlag || false;
        if (bottom <= 3 && requestFlag) {
            this.props.requestDataBack()
        }

        var pos = {
            top: top,
            bottom: bottom,
            left: left,
            right: right
        };
        this.runFunc('scrollbarScrollThrottle');
        this.setState({handlerPos: pos});


    };

    handleVerticalHandlerMouseDown = (d, e) => {
        this.lastContainerScrollTop = this.el.scrollTop;
        this.lastContainerScrollLeft = this.el.scrollLeft;

        this.activeHandler = d;
        this.lastMousePos = {
            top: e.clientY,
            left: e.clientX
        };
        this.setState({noselect: true});
    };

    handleHandlerMouseMove = e => {
        if (this.activeHandler === VERTICAL) {
            var delY = e.clientY - this.lastMousePos.top;
            this.el.scrollTop = this.lastContainerScrollTop + delY / this.el.offsetHeight * this.lastScrollHeight;
        }
        if (this.activeHandler === HORIZONTAL) {
            var delX = e.clientX - this.lastMousePos.left;
            this.el.scrollLeft = this.lastContainerScrollLeft + delX / this.el.offsetWidth * this.lastScrollWidth;
        }
    };

    handleHandlerMouseUp = () => {
        this.lastMousePos = null;
        this.activeHandler = null;
        this.setState({noselect: false});
    };
    proportionFn = () => {
        const browserInfo = this.browser();
        const chromeVersion = browserInfo.chrome;

        let proportion = window.innerWidth * 16 / 1920;
        if (chromeVersion < 79) {
            const devicePixelRatio = window.devicePixelRatio;
            proportion = proportion / devicePixelRatio <= 12 ? 12 : proportion * devicePixelRatio;
        }
        return proportion
    };

    browser = () => {
        const ua = navigator.userAgent;
        const ret = {};
        const webkit = ua.match(/WebKit\/([\d.]+)/);
        const chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/);
        // eslint-disable-next-line no-useless-escape
        const ie = ua.match(/MSIE\s([\d\.]+)/) || ua.match(/(?:trident)(?:.*rv:([\w.]+))?/i);
        const firefox = ua.match(/Firefox\/([\d.]+)/);
        const safari = ua.match(/Safari\/([\d.]+)/);
        const opera = ua.match(/OPR\/([\d.]+)/);

        webkit && (ret.webkit = parseFloat(webkit[1]));
        chrome && (ret.chrome = parseFloat(chrome[1]));
        ie && (ret.ie = parseFloat(ie[1]));
        firefox && (ret.firefox = parseFloat(firefox[1]));
        safari && (ret.safari = parseFloat(safari[1]));
        opera && (ret.opera = parseFloat(opera[1]));
        return ret;
    };

    componentDidMount() {
        const realScrollBar = 17;//17*window.devicePixelRatio;;
        const proportion = this.proportionFn();
        this.setState({
            browserOffset: realScrollBar / proportion
        });
        document.addEventListener('mousemove', this.handleHandlerMouseMove);
        document.addEventListener('mouseup', this.handleHandlerMouseUp);
        document.addEventListener('readystatechange', this.handleReadyStateChange);

        this.prepareScrollbar();
    }

    componentWillUnmount() {
        document.removeEventListener('mousemove', this.handleHandlerMouseMove);
        document.removeEventListener('mouseup', this.handleHandlerMouseUp);
        document.removeEventListener('readystatechange', this.handleReadyStateChange);

        clearTimeout(this.handlerHider);
    }


    componentWillReceiveProps(nextProps) {
        let updateScrollBar = nextProps.updateScrollBar;
        if (updateScrollBar) {
            setTimeout(() => {
                this.handlerContainerScroll();
            }, 100);
        }
        if (nextProps.scrollTop) {
            const scrollBox = document.getElementById(this.props.scrollId || "scrollBox");
            scrollBox.scrollTop = nextProps.scrollTop || 0;
        }
    }

    componentDidUpdate = (prevProps) => {
        this.updateTrackVisibilities();
    };


    render() {
        // Dynamic styles
        let showHorizontalTrack = this.state.showHorizontalTrack;
        let showVeriticalTrack = this.state.showVeriticalTrack;
        let marginBottom = showHorizontalTrack ? `${this.state.browserOffset - hoScrollBarWidth}rem` : `${this.state.browserOffset}rem`;

        let containerStyles = {
            paddingBottom: this.props.fixed ? 0 : (showHorizontalTrack ? this.props.tracksize : 0),
            paddingRight: this.props.fixed ? 0 : (showVeriticalTrack ? this.props.tracksize : 0),
            marginRight: showVeriticalTrack ? `-${this.state.browserOffset - veScrollBarWidth}rem` : `-${this.state.browserOffset}rem`,
            marginBottom: "-" + marginBottom,
            maxHeight: this.props.maxHeight ? `${parseFloat(this.props.maxHeight) + parseFloat(this.state.browserOffset)}rem` : '20rem',
        };
        if (this.state.noselect) {
            containerStyles.MozUserSelect = 'none';
            containerStyles.WebkitUserSelect = 'none';
            containerStyles.msUserSelect = 'none';
        }
        let verticalTrackStyles = {
            bottom: showHorizontalTrack ? this.props.tracksize : '0',
            backgroundColor: this.props.scrollWrapColor,
            opacity: 1
        };
        let horizontalTrackStyles = {
            right: showVeriticalTrack ? this.props.tracksize : '0',
            backgroundColor: this.props.scrollWrapColor,
            opacity: 1
        };
        let verticalHandlerStyles = {
            top: this.state.handlerPos.top + '%',
            bottom: this.state.handlerPos.bottom + '%',
            opacity: this.state.hideHandler ? 0 : 1
        };
        let horizontalHandlerStyles = {
            left: this.state.handlerPos.left + '%',
            right: this.state.handlerPos.right + '%',
            opacity: this.state.hideHandler ? 0 : 1
        };
        return (
            <div
                className={`FreeScrollbar ${this.props.className}`}
                style={{...this.props.style, ...styles.main}}
            >
                <div
                    id={this.props.scrollId || "scrollBox"}
                    className="FreeScrollbar-container"
                    style={{...containerStyles, ...styles.container}}
                    ref={container => this.el = container}
                    onScroll={this.handlerContainerScroll}
                >
                    {this.props.children}
                </div>
                {this.state.showVeriticalTrack ?
                    <div
                        className={`FreeScrollbar-vertical-track ${this.props.className ? this.props.className + '-vertical-track' : ''}`}
                        style={this.props.scrollWrapColor ? Object.assign(verticalTrackStyles, styles.track.vertical, {backgroundColor: `${this.props.scrollWrapColor}`}) : Object.assign(verticalTrackStyles, styles.track.vertical)}
                    >
                        <div
                            className={`FreeScrollbar-vertical-handler ${this.props.className ? this.props.className + '-vertical-handler' : ''}`}
                            onMouseDown={this.handleVerticalHandlerMouseDown.bind(this, VERTICAL)}
                            style={this.props.scrollBarColor ? Object.assign(verticalHandlerStyles, styles.handler.vertical, {backgroundColor: `${this.props.scrollBarColor}`}) : Object.assign(verticalHandlerStyles, styles.handler.vertical)}></div>
                    </div>
                    : null}
                {showHorizontalTrack ?
                    <div
                        className={`FreeScrollbar-horizontal-track ${this.props.className ? this.props.className + '-horizontal-track' : ''}`}
                        style={this.props.scrollWrapColor ? Object.assign(horizontalTrackStyles, styles.track.horizontal, {backgroundColor: `${this.props.scrollWrapColor}`}) : Object.assign(horizontalTrackStyles, styles.track.horizontal)}
                    >
                        <div
                            className={`FreeScrollbar-horizontal-handler ${this.props.className ? this.props.className + '-horizontal-handler' : ''}`}
                            onMouseDown={this.handleVerticalHandlerMouseDown.bind(this, HORIZONTAL)}
                            style={this.props.scrollBarColor ? Object.assign(horizontalHandlerStyles, styles.handler.horizontal, {backgroundColor: `${this.props.scrollBarColor}`}) : Object.assign(horizontalHandlerStyles, styles.handler.horizontal)}></div>
                    </div>
                    : null}
                {showHorizontalTrack && showVeriticalTrack && !this.props.fixed ?
                    <div
                        className={`FreeScrollbar-square ${this.props.className ? this.props.className + '-square' : ''}`}
                        style={styles.square}></div>
                    : null}
            </div>
        )
    }
};
